:host {
  display: block;
  position: relative;
}

.spw-accordion {
  border-top: 1px solid var(--spw-color-themes-grey-grey-300);
}
